import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import {
  InitialParams,
  StandardParams,
  UsePaginatedEndpointResult,
} from 'hooks/usePaginatedEndpoint/types';

import { bansApi } from './api';
import {
  BanQueryParams,
  BansByUserResponseData,
  BansByUserResponseDataBans,
  BanSortKey,
} from './types';

type Params = StandardParams<BanSortKey> & BanQueryParams;

export type BansByUserEndpointResult = UsePaginatedEndpointResult<
  BansByUserResponseDataBans,
  BanSortKey,
  Params
>;

export const useBansByUser = (
  initialParams: InitialParams<BanSortKey, Params>,
): BansByUserEndpointResult =>
  usePaginatedEndpoint<
    BansByUserResponseDataBans,
    BansByUserResponseData,
    BanSortKey,
    Params
  >({
    endpoint: bansApi.getBansByUser,
    itemsSelector: ({ bans }) => bans,
    totalSelector: ({ number_of_users }) => number_of_users,
    initialParams,
  });
